import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { fetchNftDataConfig, fetchPopularDataConfig, fetchGamesDataConfig } from "../utils/dataConfig";

export const useRetrieveCategory = (slicedUrl, categoryName, page) => {

	const dispatch = useDispatch();
	const [categoryData, setCategoryData] = useState();

	useEffect(() => {
		let selectedConfigArray = null;
		switch (slicedUrl) {
			case "browse":
			case "nfts":
				selectedConfigArray = fetchNftDataConfig;
				break;
			case "games":
				selectedConfigArray = fetchGamesDataConfig;
				break;
			case "popular":
				selectedConfigArray = fetchPopularDataConfig;
				break;
			default:
				break;
		}

		const [data] = selectedConfigArray.filter(el => el.genre === categoryName);
		dispatch(data.thunk(`${data.url}&page=${page}`));
		setCategoryData(data);

	}, [dispatch, categoryName, slicedUrl, page])

	return categoryData;
}